import { global } from "./bundle/global.js";
import { ButtonList } from "./bundle/button-list.js";
import { CollectionLayout } from "./bundle/collection-layout.js";
import { ProductCard } from "./bundle/product-card.js";
import { ProductCardImages } from "./bundle/product-card-images.js";
import { ProductForm } from "./bundle/product-form.js";
import { ProductInfoSwatches } from "./bundle/product-info-swatches.js";
import { QuickView } from "./bundle/quick-view.js";
import { NumberCounter } from "./bundle/number-counter.js";

export default function () {
  global();
  ButtonList();
  CollectionLayout();
  ProductCard();
  ProductCardImages();
  ProductForm();
  ProductInfoSwatches();
  QuickView();
  NumberCounter();
}
